import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { authPath } from '../hooks/auth-path'
import { AuthHead, AuthMark, AuthPage } from '../../../../shared/sso-workspace/auth-card'

export const PasswordResult = () => {
  const { email } = useParams()

  return (
    <AuthPage labelledBy="password-result-title">
      <AuthHead id="password-result-title" title="Check your email" mark={<AuthMark tone="ok">✓</AuthMark>} />
      <p className="m-0">
        If <strong>{email}</strong> has an EducationXR account, we've sent it a link to choose a new password. The link works for a limited time.
      </p>
      <p className="m-0 sw-hint">Nothing there after a few minutes? Check your spam or junk folder, or ask your organization's EducationXR administrator.</p>
      <Link replace className="btn sw-btn sa-block" to={authPath('/auth/email', { email })}>Back to sign in</Link>
    </AuthPage>
  )
}
